import React, {useContext} from 'react';

import {TeaserLayoutProps} from '~/src/components/teaser/layout/default/TeaserLayoutDefault';
import PageContext from '~/src/components/context/PageContext';
import {createTopItemTracker} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './TeaserLayoutPopularity.module.scss';
import i18n from './TeaserLayoutPopularity.i18n.json';

const getTranslation = initPolyglot(i18n);

const TeaserLayoutPopularity = ({children, title, showTitle, options}: TeaserLayoutProps) => {
    const {gtmPageType} = useContext(PageContext);
    const subtitle =
        options?.timeFrame && ['12h', '1d', '3d', '1w'].includes(options?.timeFrame)
            ? getTranslation(`subtitle-${options?.timeFrame}`)
            : getTranslation('subtitle-1d');

    return (
        <React.Fragment>
            <header className={css.titleHeader}>
                <React.Fragment>
                    {showTitle && title ? <h2 className={css.title}>{title}</h2> : <h2 className={css.title}>{getTranslation('title')}</h2>}
                    <span className={css.subtitle}>{subtitle}</span>
                </React.Fragment>
            </header>
            <div className={css.container}>
                <div className={css.teasers}>
                    {children.map((element, index) =>
                        React.cloneElement(element, {
                            ...element.props,
                            onClick: createTopItemTracker(
                                GtmEvents.WIDGET_MOST_POPULAR,
                                gtmPageType,
                                element.props.url?.substr(-12) || '',
                                index,
                                element.props.title
                            )
                        })
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default TeaserLayoutPopularity;
